var _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404Page = function Svg404Page(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 350 350"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCCD1",
    stroke: "#000",
    d: "M127.771 266.787c0-10.77 8.73-19.5 19.5-19.5H202c10.77 0 19.5 8.73 19.5 19.5v9.294a4.5 4.5 0 0 1-4.5 4.5h-84.729a4.5 4.5 0 0 1-4.5-4.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.137,
    cy: 279.568,
    fill: "#000",
    rx: 91.738,
    ry: 2.522
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCCD1",
    stroke: "#000",
    d: "M127.771 270.822c0-10.77 8.73-19.5 19.5-19.5H202c10.77 0 19.5 8.73 19.5 19.5v5.259a4.5 4.5 0 0 1-4.5 4.5h-84.729a4.5 4.5 0 0 1-4.5-4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "bevel",
    d: "m188.097 247.291-2.493 4.035v-18.66h2.493z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    d: "M162.671 232.157h22.932v19.173h-22.932z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    stroke: "#000",
    d: "M83.78 72.062a4.475 4.475 0 0 1 4.983-3.933L278.067 90.9a4.526 4.526 0 0 1 3.952 5.008l-14.811 128.197c-1.236 10.698-10.906 18.328-21.598 17.042L86.092 221.959c-10.693-1.286-18.359-11.002-17.123-21.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    d: "M83.815 72.03a4.475 4.475 0 0 1 4.985-3.932l189.27 22.764a4.524 4.524 0 0 1 3.951 5.008l-13.694 118.525-198.206-23.839z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m69.574 191.218 198.048 23.647M127.289 105.203l20.091 25.753M124.605 128.238l25.461-20.322M209.476 115.003l20.09 25.754M206.792 138.038l25.46-20.322M114.89 172.687c20.035-15.465 70.372-34.44 111.437 13.38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M162.67 234.683h23.616l-11.468-2.017-12.148-1.513z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M173.637 217.536c0 3.072-2.46 5.552-5.483 5.552s-5.483-2.48-5.483-5.552 2.461-5.552 5.483-5.552c3.023 0 5.483 2.481 5.483 5.552Z"
  })));
};
export default Svg404Page;